module.exports = __webpack_public_path__ + "img/linea-punteada-desp-mob.1d03a8eb.svg";